import { Injectable } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root'
})
export class NgToastTranslocoService {
  private readonly defaultDuration = 5000;

  constructor(
    private toast: HotToastService,
    private translocoService: TranslocoService
  ) { }

  gettransloco(data: string): string {
    const toastTxt = this.translocoService.translate(data, {}, this.translocoService.getActiveLang());
    return toastTxt;
  }

  private getDefaultOptions() {
    return {
      autoClose: true,
      dismissible: true,
      duration: this.defaultDuration,
    };
  }

  private showToast(type: 'success' | 'error' | 'warning', message: string) {
    const options = this.getDefaultOptions();

    if (type === 'success') {
      this.toast.success(message, options);
      return;
    }

    if (type === 'error') {
      this.toast.error(message, options);
      return;
    }

    this.toast.warning(message, options);
  }

  toastError(data: string) {
    this.showToast('warning', this.gettransloco(data));
  }

  toastErrorMsg(data: string) {
    this.showToast('error', this.gettransloco(data));
  }

  toastSuccess(data: string) {
    this.showToast('success', this.gettransloco(data));
  }

  toastSuccessMsg(data: string) {
    this.showToast('success', data);
  }

  toastWarning(data: string) {
    this.showToast('warning', this.gettransloco(data));
  }

  toastWarningMsg(data: string) {
    this.showToast('warning', data);
  }

  errorWarning(data: string) {
    const toasetData = this.gettransloco(data);
    this.showToast('warning', toasetData);
  }
}
